import removeNamespace from "../namespace-helper"
import axios from "../../plugins/axios"

export const Types = {
  getters: {
    IS_AUTHENTICATED: "auth/IS_AUTHENTICATED",
    AUTH_STATUS: "auth/AUTH_STATUS",
    AUTH_USER: "auth/AUTH_USER",
    USER_GROUP: "auth/USER_GROUP",
  },
  actions: {
    AUTH_LOGIN: "auth/AUTH_LOGIN",
    AUTH_LOGOUT: "auth/AUTH_LOGOUT",
    UPDATE_USER: "auth/UPDATE_USER",
    UPDATE_USER_GROUP: "auth/UPDATE_USER_GROUP",
  },
  mutations: {
    AUTH_LOGIN: "auth/AUTH_LOGIN",
    AUTH_SUCCESS: "auth/AUTH_SUCCESS",
    AUTH_ERROR: "auth/AUTH_ERROR",
    AUTH_LOGOUT: "auth/AUTH_LOGOUT",
    UPDATE_TOKEN: "auth/UPDATE_TOKEN",
    UPDATE_USER: "auth/UPDATE_USER",
    UPDATE_USER_GROUP: "auth/UPDATE_USER_GROUP",
  },
}

const _types = removeNamespace("auth/", Types)

const state = {
  token: "",
  status: "",
  user: {},
  group: {},
}

// getters
const getters = {
  [_types.getters.IS_AUTHENTICATED]: state => !!state.token,
  [_types.getters.AUTH_STATUS]: state => state.status,
  [_types.getters.AUTH_USER]: state => state.user,
  [_types.getters.USER_GROUP]: state => state.group,
}

// actions
const actions = {
  [_types.actions.AUTH_LOGIN]: ({ commit }, credentials) => {
    return new Promise((resolve, reject) => {
      commit(_types.actions.AUTH_LOGIN)
      axios
        .post("office/login", credentials )
        .then(response => {
          const user = response.data

          // Set the token
          const token = "Bearer " + user.token
          commit(_types.mutations.UPDATE_TOKEN, token)
          axios.defaults.headers.common["Authorization"] = token

          // Set the user
          commit(_types.mutations.AUTH_SUCCESS, user)
          resolve(response)
        })
        .catch(error => {
          commit(_types.mutations.AUTH_ERROR, error)
          reject(error)
        })
    })
  },
  [_types.actions.AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(_types.mutations.AUTH_LOGOUT)

      localStorage.clear()
      axios.defaults.headers.common["Authorization"] = ""

      delete axios.defaults.headers.common["Authorization"]

      resolve()
    })
  },
  [_types.actions.UPDATE_USER]: ({ commit, state }, user) => {
    return new Promise(resolve => {
      const previousVersion = { ...state.user }

      commit(_types.mutations.UPDATE_USER, user)

      resolve(previousVersion)
    })
  },
  [_types.actions.UPDATE_USER_GROUP]: ({ commit, state }, group) => {
    return new Promise(resolve => {
      const previousVersion = { ...state.group }

      commit(_types.mutations.UPDATE_USER_GROUP, group)

      resolve(previousVersion)
    })
  },
}

// mutations
const mutations = {
  [_types.mutations.AUTH_LOGIN]: state => {
    state.status = "loading"
  },
  [_types.mutations.AUTH_SUCCESS]: (state, user) => {
    state.status = "success"
    state.user = user
  },
  [_types.mutations.AUTH_ERROR]: state => {
    state.status = "error"
  },
  [_types.mutations.AUTH_LOGOUT]: state => {
    state.status = "logged out"
  },
  [_types.mutations.UPDATE_TOKEN]: (state, token) => {
    state.token = token
  },
  [_types.mutations.UPDATE_USER]: (state, user) => {
    state.user = user
  },
  [_types.mutations.UPDATE_USER_GROUP]: (state, group) => {
    state.group = group
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
